import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { TRUST } from "../../lib/content";
import { Star8 } from "./GeometricDivider";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="pattern-emerald text-ivory mt-24">
      <div className="container-page py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <span className="grid place-items-center h-12 w-12 rounded-full border border-gold/50">
              <Star8 size={22} color="#C8A24B" />
            </span>
            <div className="leading-tight">
              <p className="font-serif text-xl">Hazrat Sufi Sarkar</p>
              <p className="text-[10px] uppercase tracking-[0.3em] text-gold">Habibul Mahboob</p>
            </div>
          </div>
          <div className="mt-2">
            <p className="text-[10px] uppercase tracking-[0.35em] text-gold/90 mb-2">Ya Sarkar Nawaz Allah</p>
            <p className="calligraphy text-gold text-base leading-snug" style={{ letterSpacing: "0.01em" }}>
              HAZRAT ABU MUHAMMAD BADE PEER<br />
              MUHIYYUL SHAH NAWAZ ALLAH<br />
              QADIR GHOUS-E-RABBANI
            </p>
          </div>
          <p className="text-ivory/70 mt-4 text-sm leading-relaxed">
            A charitable trust devoted to solving life's problems through divine blessings and compassionate service.
          </p>
        </div>

        <div>
          <h4 className="text-gold uppercase tracking-[0.25em] text-xs mb-5">Visit</h4>
          <ul className="space-y-3 text-sm text-ivory/80">
            <li className="flex gap-3"><MapPin size={16} className="text-gold mt-0.5 shrink-0" /><span>{TRUST.address}</span></li>
            <li className="flex gap-3"><Phone size={16} className="text-gold mt-0.5 shrink-0" /><div>{TRUST.phones.map(p => <div key={p}>{p}</div>)}</div></li>
            <li className="flex gap-3"><Mail size={16} className="text-gold mt-0.5 shrink-0" /><a href={`mailto:${TRUST.email}`} className="underline-offset-4 hover:underline">{TRUST.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gold uppercase tracking-[0.25em] text-xs mb-5">Pathways</h4>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li><Link to="/about" className="hover:text-gold">About Hazrat Sufi Sarkar</Link></li>
            <li><Link to="/sufism" className="hover:text-gold">Sufism</Link></li>
            <li><Link to="/services" className="hover:text-gold">Services & Solutions</Link></li>
            <li><Link to="/the-book" className="hover:text-gold">The Book</Link></li>
            <li><Link to="/book" className="hover:text-gold">Book Online</Link></li>
            <li><Link to="/mecca-majlis" className="hover:text-gold">Mecca Majlis</Link></li>
            <li><Link to="/followers" className="hover:text-gold">Followers (Murids)</Link></li>
            <li><Link to="/donate" className="hover:text-gold">Donate</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gold uppercase tracking-[0.25em] text-xs mb-5">Connect</h4>
          <div className="flex items-center gap-3">
            <a data-testid="social-facebook" href={TRUST.socials.facebook} target="_blank" rel="noreferrer" className="grid place-items-center h-10 w-10 rounded-full border border-gold/40 hover:bg-gold hover:text-emerald-deep transition-colors">
              <Facebook size={16} />
            </a>
            <a data-testid="social-twitter" href={TRUST.socials.twitter} target="_blank" rel="noreferrer" className="grid place-items-center h-10 w-10 rounded-full border border-gold/40 hover:bg-gold hover:text-emerald-deep transition-colors">
              <Twitter size={16} />
            </a>
            <a data-testid="social-instagram" href={TRUST.socials.instagram} target="_blank" rel="noreferrer" className="grid place-items-center h-10 w-10 rounded-full border border-gold/40 hover:bg-gold hover:text-emerald-deep transition-colors">
              <Instagram size={16} />
            </a>
          </div>
          <p className="mt-8 text-xs text-ivory/60">
            All contributions support the trust's charitable work — providing food, clothing, shelter, education, and healthcare to the needy.
          </p>
        </div>
      </div>
      <div className="border-t border-gold/15">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-ivory/60">
          <p>© {new Date().getFullYear()} {TRUST.trust}. All rights reserved.</p>
          <p className="calligraphy text-gold">Bismillah-ir-Rahman-ir-Raheem</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
